/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { CLEAR_ALL_STATES, SET_AUTH_TOKEN_DATA } from 'state/actions/auth_status';
// utils
import { processFormActions, getFormDefaultState } from '@insticator/insticator-ui'; // iui-utils



/* ========== ~~~~~~~~~~  AUTH STATUS : REDUCER ~~~~~~~~~~ ========== */


//----default State ----//

const transpileRequestDemoForm = data => ({
    fname: { value: !!data.firstName ? data.firstName : '', valid: !!data.firstName ? true : null }, // valid: null / true / false
    lname: { value: !!data.lastName ? data.lastName : '', valid: !!data.lastName ? true : null },
    email: { value: !!data.email ? data.email : '', valid: !!data.email ? true : null },
    phone: { value: !!data.phone ? data.phone : '', valid: !!data.phone ? true : null },
    domain: { value: !!data.domain ? data.domain : '', valid: !!data.domain ? true: null },
    pageviews: {value: !!data.pageviews ? data.pageviews : '', valid: !!data.pageviews ? true: null }
});
const transpileResetPasswordForm = data => ({
    email: { value: !!data.email ? data.email : '', valid: !!data.email ? true : null }
});
const transpileCompletePasswordReset = data => ({
    newPassword: {value: !!data.newPassword ? data.newPassword : '', valid: !!data.newPassword ? true : null },
    confirmedPassword: {value: !!data.confirmedPassword ? data.confirmedPassword : '', valid: !!data.confirmedPassword ? true : null }
});
const transpileCompleteSignUpForm = data => ({
    newPassword: {value: !!data.newPassword ? data.newPassword : '', valid: !!data.newPassword ? true : null },
    confirmedPassword: {value: !!data.confirmedPassword ? data.confirmedPassword : '', valid: !!data.confirmedPassword ? true : null }
});
const transpileSignInForm = data =>({
    email: { value: !!data.email ? data.email : '', valid: !!data.email ? true : null },
    signinpassword: {value: !!data.password ? data.password : '', valid: !!data.password ? true : null },
    rememberme: {value: !!data.rememberme ? data.rememberme : '', valid: true }
});



//TODO We will store "Remeber Me" in a cookie (for signup form)

const defaultState = {
    requestdemo: getFormDefaultState(transpileRequestDemoForm),
    completesignup: getFormDefaultState(transpileCompleteSignUpForm),
    resetpassword: getFormDefaultState(transpileResetPasswordForm),
    signin: getFormDefaultState(transpileSignInForm),
    completepasswordreset: getFormDefaultState(transpileCompletePasswordReset),
    tokenData: {
        tokenUUID: null,
        tokenType: null, //RESET_PASSWORD
        userUUID: null,
        email: null,
        error: null,
        validToken: null
    }
};

const getFormTranspiler = (formName) =>{
    switch (formName) {
        case 'requestdemo':
            return transpileRequestDemoForm;
        case 'completesignup':
            return transpileCompleteSignUpForm;
        case 'resetpassword':
            return transpileResetPasswordForm;
        case 'signin':
        default:
            return transpileSignInForm;
        case 'completepasswordreset':
            return transpileCompletePasswordReset;
    }
};

// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const assignedForms = Object.keys(defaultState);

const authStatus = (state = defaultState, action) => {
   if(action.type.startsWith('FORM_') && assignedForms.includes(action.formName)){
       return processFormActions(state, action, action.formName, getFormTranspiler(action.formName))
   }
    switch (action.type) {
        case CLEAR_ALL_STATES:
            return defaultState;
        case SET_AUTH_TOKEN_DATA:
            let newState = JSON.parse(JSON.stringify(state));
            return { ...newState, tokenData: {...newState.tokenData, ...action.data}};
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default authStatus;
